// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.descritpion-container{
  width: 100vw;
  border: 1px solid black;
  /* background-color: white; */
  padding: 10px;
}


/* Control Panel */
.gd-control-panel-container{
  justify-content: center;
  min-width: 100vh;
  margin: 10px 2rem;
  display: flex;
}

.control-pannel-container{
  /* background-color: white; */
  display: flex;
  margin-right: 10px;


}

.input-container{
  min-width: 180px;
  height: -moz-fit-content;
  height: fit-content;
  

}

.input-box-name{
  font-size: 1.2rem;
  font-weight: bolder;
  height: 30px;
}
.input-box{
  width: 150px;
  min-width: 150px;
  font-size: 0.8rem;
  padding: 5px;
  height: 30px;
  border: none;
  border-bottom: 1px solid black;
}

.progress-button{
  width: 50px;
  height: 30px;
  line-height: 30px;
  font-size: 1.5rem;
  background-color: white;
  box-shadow: 1px 1px 5px grey;


  border: none;


}
.progress-button img{
  max-width: 30px;
  max-height: 30px;
}

.progress-button:hover{
  background-color: #FFB800;
  cursor: pointer;
}

.progress-input{

  width: 100px;
  height: 30px;
}

/* GD Graph */

.gd-lable-container{
  display: flex;
  padding: 25px;
}

.gd-y-label{

  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  font-weight: bolder;
  font-size: 20px;

}

.gd-x-label{

  width: 35px;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  font-weight: bolder;
  font-size: 20px;

}


/* Data Container */
.data-container{
  min-width: 500px;
  /* background-color: white; */
  display: flex;
  justify-content: center;

}

/* Detail for Loss */
.loss-detail-container{
  width: 100%;
  line-height: 100%;
  /* background-color: white;
  box-shadow: 1px 1px 5px grey; */
  margin: 3px;

}
.loss-detail-container div{
  padding:5px
}

.selected {
  border: 2px solid red;
}

/* Progress Control Panel */
.progress-control-container{
  width: 500px;
  min-width: 400px;
  padding: auto; 


  /* border-left: 1px solid black; */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.progress-control-container div{
  margin: 0 10px;
}


.vis-container{
  display: flex;
  margin: 10px 2rem;
}

.data-container{
  display: flex;
  flex-wrap: wrap;
  width: 600px;
}

.gradient-div{
  width: 50px;
  text-align: center;
  height: 30px;
  box-shadow: 1px 1px 1px grey;
  margin: 2px;
}

/* Gradient Descent Graph */
.gradient-descent-network-graph{
  width: 1000px;
  min-width: 800px;
  height: 700px;
  /* background-color: white; */
}


/* Data Visualization */
.color-map-gradient{
  display: flex;
  width: 100%;
  box-shadow: 1px 1px 5px grey ;
}

.color-map-bar{
  width: 50px;
  height: 20px;
  font-size: 12px;
  line-height: 12px;
  /* padding: 5px; */
}`, "",{"version":3,"sources":["webpack://./src/pages/ch3/GradientDescent.css"],"names":[],"mappings":";;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;AACf;;;AAGA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;;;AAGpB;;AAEA;EACE,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;;;AAGrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;;;EAG5B,YAAY;;;AAGd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,YAAY;AACd;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB,EAAE,SAAS;EAC9B,uBAAuB,EAAE,SAAS;EAClC,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB,EAAE,SAAS;EAC9B,uBAAuB,EAAE,SAAS;EAClC,mBAAmB;EACnB,eAAe;;AAEjB;;;AAGA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;;AAEzB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,iBAAiB;EACjB;iCAC+B;EAC/B,WAAW;;AAEb;AACA;EACE;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;;;EAGb,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;;AAGA,uBAAuB;AACvB;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["\n\n.descritpion-container{\n  width: 100vw;\n  border: 1px solid black;\n  /* background-color: white; */\n  padding: 10px;\n}\n\n\n/* Control Panel */\n.gd-control-panel-container{\n  justify-content: center;\n  min-width: 100vh;\n  margin: 10px 2rem;\n  display: flex;\n}\n\n.control-pannel-container{\n  /* background-color: white; */\n  display: flex;\n  margin-right: 10px;\n\n\n}\n\n.input-container{\n  min-width: 180px;\n  height: fit-content;\n  \n\n}\n\n.input-box-name{\n  font-size: 1.2rem;\n  font-weight: bolder;\n  height: 30px;\n}\n.input-box{\n  width: 150px;\n  min-width: 150px;\n  font-size: 0.8rem;\n  padding: 5px;\n  height: 30px;\n  border: none;\n  border-bottom: 1px solid black;\n}\n\n.progress-button{\n  width: 50px;\n  height: 30px;\n  line-height: 30px;\n  font-size: 1.5rem;\n  background-color: white;\n  box-shadow: 1px 1px 5px grey;\n\n\n  border: none;\n\n\n}\n.progress-button img{\n  max-width: 30px;\n  max-height: 30px;\n}\n\n.progress-button:hover{\n  background-color: #FFB800;\n  cursor: pointer;\n}\n\n.progress-input{\n\n  width: 100px;\n  height: 30px;\n}\n\n/* GD Graph */\n\n.gd-lable-container{\n  display: flex;\n  padding: 25px;\n}\n\n.gd-y-label{\n\n  display: flex;\n  align-items: center; /* 垂直居中 */\n  justify-content: center; /* 水平居中 */\n  font-weight: bolder;\n  font-size: 20px;\n\n}\n\n.gd-x-label{\n\n  width: 35px;\n  display: flex;\n  align-items: center; /* 垂直居中 */\n  justify-content: center; /* 水平居中 */\n  font-weight: bolder;\n  font-size: 20px;\n\n}\n\n\n/* Data Container */\n.data-container{\n  min-width: 500px;\n  /* background-color: white; */\n  display: flex;\n  justify-content: center;\n\n}\n\n/* Detail for Loss */\n.loss-detail-container{\n  width: 100%;\n  line-height: 100%;\n  /* background-color: white;\n  box-shadow: 1px 1px 5px grey; */\n  margin: 3px;\n\n}\n.loss-detail-container div{\n  padding:5px\n}\n\n.selected {\n  border: 2px solid red;\n}\n\n/* Progress Control Panel */\n.progress-control-container{\n  width: 500px;\n  min-width: 400px;\n  padding: auto; \n\n\n  /* border-left: 1px solid black; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n}\n\n.progress-control-container div{\n  margin: 0 10px;\n}\n\n\n.vis-container{\n  display: flex;\n  margin: 10px 2rem;\n}\n\n.data-container{\n  display: flex;\n  flex-wrap: wrap;\n  width: 600px;\n}\n\n.gradient-div{\n  width: 50px;\n  text-align: center;\n  height: 30px;\n  box-shadow: 1px 1px 1px grey;\n  margin: 2px;\n}\n\n/* Gradient Descent Graph */\n.gradient-descent-network-graph{\n  width: 1000px;\n  min-width: 800px;\n  height: 700px;\n  /* background-color: white; */\n}\n\n\n/* Data Visualization */\n.color-map-gradient{\n  display: flex;\n  width: 100%;\n  box-shadow: 1px 1px 5px grey ;\n}\n\n.color-map-bar{\n  width: 50px;\n  height: 20px;\n  font-size: 12px;\n  line-height: 12px;\n  /* padding: 5px; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
